import AddressesPage from './AddressesPage';

export default AddressesPage;


// WEBPACK FOOTER //
// ./src/components/AddressesPage/index.jsx